(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __reExport = (target, module, desc) => {
    if (module && typeof module === "object" || typeof module === "function") {
      for (let key of __getOwnPropNames(module))
        if (!__hasOwnProp.call(target, key) && key !== "default")
          __defProp(target, key, { get: () => module[key], enumerable: !(desc = __getOwnPropDesc(module, key)) || desc.enumerable });
    }
    return target;
  };
  var __toModule = (module) => {
    return __reExport(__markAsModule(__defProp(module != null ? __create(__getProtoOf(module)) : {}, "default", module && module.__esModule && "default" in module ? { get: () => module.default, enumerable: true } : { value: module, enumerable: true })), module);
  };

  // node_modules/easytimer.js/dist/easytimer.js
  var require_easytimer = __commonJS({
    "node_modules/easytimer.js/dist/easytimer.js"(exports, module) {
      (function(global, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory(global.easytimer = {}));
      })(exports, function(exports2) {
        "use strict";
        function _typeof(obj) {
          "@babel/helpers - typeof";
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function(obj2) {
              return typeof obj2;
            };
          } else {
            _typeof = function(obj2) {
              return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
            };
          }
          return _typeof(obj);
        }
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function ownKeys(object2, enumerableOnly) {
          var keys = Object.keys(object2);
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object2);
            if (enumerableOnly)
              symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
              });
            keys.push.apply(keys, symbols);
          }
          return keys;
        }
        function _objectSpread2(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) {
              ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }
          return target;
        }
        function leftPadding(string, padLength, character) {
          var i;
          var characters = "";
          string = typeof string === "number" ? String(string) : string;
          if (string.length > padLength) {
            return string;
          }
          for (i = 0; i < padLength; i = i + 1) {
            characters += String(character);
          }
          return (characters + string).slice(-characters.length);
        }
        function TimeCounter() {
          this.reset();
        }
        TimeCounter.prototype.toString = function() {
          var units = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["hours", "minutes", "seconds"];
          var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ":";
          var leftZeroPadding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
          units = units || ["hours", "minutes", "seconds"];
          separator = separator || ":";
          leftZeroPadding = leftZeroPadding || 2;
          var arrayTime = [];
          var i;
          for (i = 0; i < units.length; i = i + 1) {
            if (this[units[i]] !== void 0) {
              if (units[i] === "secondTenths") {
                arrayTime.push(this[units[i]]);
              } else {
                arrayTime.push(leftPadding(this[units[i]], leftZeroPadding, "0"));
              }
            }
          }
          return arrayTime.join(separator);
        };
        TimeCounter.prototype.reset = function() {
          this.secondTenths = 0;
          this.seconds = 0;
          this.minutes = 0;
          this.hours = 0;
          this.days = 0;
        };
        function EventEmitter() {
          this.events = {};
        }
        EventEmitter.prototype.on = function(event, listener) {
          var _this = this;
          if (!Array.isArray(this.events[event])) {
            this.events[event] = [];
          }
          this.events[event].push(listener);
          return function() {
            return _this.removeListener(event, listener);
          };
        };
        EventEmitter.prototype.removeListener = function(event, listener) {
          if (Array.isArray(this.events[event])) {
            var eventIndex = this.events[event].indexOf(listener);
            if (eventIndex > -1) {
              this.events[event].splice(eventIndex, 1);
            }
          }
        };
        EventEmitter.prototype.emit = function(event) {
          var _this2 = this;
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          if (Array.isArray(this.events[event])) {
            this.events[event].forEach(function(listener) {
              return listener.apply(_this2, args);
            });
          }
        };
        var SECOND_TENTHS_PER_SECOND = 10;
        var SECONDS_PER_MINUTE = 60;
        var MINUTES_PER_HOUR = 60;
        var HOURS_PER_DAY = 24;
        var SECOND_TENTHS_POSITION = 0;
        var SECONDS_POSITION = 1;
        var MINUTES_POSITION = 2;
        var HOURS_POSITION = 3;
        var DAYS_POSITION = 4;
        var SECOND_TENTHS = "secondTenths";
        var SECONDS = "seconds";
        var MINUTES = "minutes";
        var HOURS = "hours";
        var DAYS = "days";
        var VALID_INPUT_VALUES = [SECOND_TENTHS, SECONDS, MINUTES, HOURS, DAYS];
        var unitsInMilliseconds = {
          secondTenths: 100,
          seconds: 1e3,
          minutes: 6e4,
          hours: 36e5,
          days: 864e5
        };
        var groupedUnits = {
          secondTenths: SECOND_TENTHS_PER_SECOND,
          seconds: SECONDS_PER_MINUTE,
          minutes: MINUTES_PER_HOUR,
          hours: HOURS_PER_DAY
        };
        function mod(number, module2) {
          return (number % module2 + module2) % module2;
        }
        function Timer3() {
          var defaultParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var counters = new TimeCounter();
          var totalCounters = new TimeCounter();
          var intervalId;
          var eventEmitter = new EventEmitter();
          var running = false;
          var paused = false;
          var precision;
          var timerTypeFactor;
          var customCallback;
          var timerConfig = {};
          var currentParams;
          var targetValues;
          var startValues;
          var countdown;
          var startingDate;
          var targetDate;
          var eventData = {
            detail: {
              timer: this
            }
          };
          setParams(defaultParams);
          function updateCounters(precision2, roundedValue) {
            var unitsPerGroup = groupedUnits[precision2];
            totalCounters[precision2] = roundedValue;
            if (precision2 === DAYS) {
              counters[precision2] = Math.abs(roundedValue);
            } else if (roundedValue >= 0) {
              counters[precision2] = mod(roundedValue, unitsPerGroup);
            } else {
              counters[precision2] = mod(unitsPerGroup - mod(roundedValue, unitsPerGroup), unitsPerGroup);
            }
          }
          function updateDays(value) {
            return updateUnitByPrecision(value, DAYS);
          }
          function updateHours(value) {
            return updateUnitByPrecision(value, HOURS);
          }
          function updateMinutes(value) {
            return updateUnitByPrecision(value, MINUTES);
          }
          function updateSeconds(value) {
            return updateUnitByPrecision(value, SECONDS);
          }
          function updateSecondTenths(value) {
            return updateUnitByPrecision(value, SECOND_TENTHS);
          }
          function updateUnitByPrecision(value, precision2) {
            var previousValue = totalCounters[precision2];
            updateCounters(precision2, calculateIntegerUnitQuotient(value, unitsInMilliseconds[precision2]));
            return totalCounters[precision2] !== previousValue;
          }
          function stopTimerAndResetCounters() {
            stopTimer();
            resetCounters();
          }
          function stopTimer() {
            clearInterval(intervalId);
            intervalId = void 0;
            running = false;
            paused = false;
          }
          function setParamsAndStartTimer(params) {
            if (!isPaused()) {
              setParams(params);
            } else {
              startingDate = calculateStartingDate();
              targetValues = setTarget(currentParams.target);
            }
            startTimer();
          }
          function startTimer() {
            var interval = unitsInMilliseconds[precision];
            if (isTargetAchieved(roundTimestamp(Date.now()))) {
              return;
            }
            intervalId = setInterval(updateTimerAndDispatchEvents, interval);
            running = true;
            paused = false;
          }
          function calculateStartingDate() {
            return roundTimestamp(Date.now()) - totalCounters.secondTenths * unitsInMilliseconds[SECOND_TENTHS] * timerTypeFactor;
          }
          function updateTimerAndDispatchEvents() {
            var currentTime = roundTimestamp(Date.now());
            var valuesUpdated = updateTimer();
            dispatchEvents(valuesUpdated);
            customCallback(eventData.detail.timer);
            if (isTargetAchieved(currentTime)) {
              stop();
              dispatchEvent("targetAchieved", eventData);
            }
          }
          function updateTimer() {
            var currentTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : roundTimestamp(Date.now());
            var elapsedTime = timerTypeFactor > 0 ? currentTime - startingDate : startingDate - currentTime;
            var valuesUpdated = {};
            valuesUpdated[SECOND_TENTHS] = updateSecondTenths(elapsedTime);
            valuesUpdated[SECONDS] = updateSeconds(elapsedTime);
            valuesUpdated[MINUTES] = updateMinutes(elapsedTime);
            valuesUpdated[HOURS] = updateHours(elapsedTime);
            valuesUpdated[DAYS] = updateDays(elapsedTime);
            return valuesUpdated;
          }
          function roundTimestamp(timestamp) {
            return Math.floor(timestamp / unitsInMilliseconds[precision]) * unitsInMilliseconds[precision];
          }
          function dispatchEvents(valuesUpdated) {
            if (valuesUpdated[SECOND_TENTHS]) {
              dispatchEvent("secondTenthsUpdated", eventData);
            }
            if (valuesUpdated[SECONDS]) {
              dispatchEvent("secondsUpdated", eventData);
            }
            if (valuesUpdated[MINUTES]) {
              dispatchEvent("minutesUpdated", eventData);
            }
            if (valuesUpdated[HOURS]) {
              dispatchEvent("hoursUpdated", eventData);
            }
            if (valuesUpdated[DAYS]) {
              dispatchEvent("daysUpdated", eventData);
            }
          }
          function isTargetAchieved(currentDate) {
            return targetValues instanceof Array && currentDate >= targetDate;
          }
          function resetCounters() {
            counters.reset();
            totalCounters.reset();
          }
          function setParams(params) {
            params = params || {};
            precision = checkPrecision(params.precision);
            customCallback = typeof params.callback === "function" ? params.callback : function() {
            };
            countdown = params.countdown === true;
            timerTypeFactor = countdown === true ? -1 : 1;
            if (_typeof(params.startValues) === "object") {
              setStartValues(params.startValues);
            } else {
              startValues = null;
            }
            startingDate = calculateStartingDate();
            updateTimer();
            if (_typeof(params.target) === "object") {
              targetValues = setTarget(params.target);
            } else if (countdown) {
              params.target = {
                seconds: 0
              };
              targetValues = setTarget(params.target);
            } else {
              targetValues = null;
            }
            timerConfig = {
              precision,
              callback: customCallback,
              countdown: _typeof(params) === "object" && params.countdown === true,
              target: targetValues,
              startValues
            };
            currentParams = params;
          }
          function checkPrecision(precision2) {
            precision2 = typeof precision2 === "string" ? precision2 : SECONDS;
            if (!isValidInputValue(precision2)) {
              throw new Error("Error in precision parameter: ".concat(precision2, " is not a valid value"));
            }
            return precision2;
          }
          function isValidInputValue(value) {
            return VALID_INPUT_VALUES.indexOf(value) >= 0;
          }
          function configInputValues(inputValues) {
            var values;
            if (_typeof(inputValues) === "object") {
              if (inputValues instanceof Array) {
                if (inputValues.length !== 5) {
                  throw new Error("Array size not valid");
                }
                values = inputValues;
              } else {
                for (var value in inputValues) {
                  if (VALID_INPUT_VALUES.indexOf(value) < 0) {
                    throw new Error("Error in startValues or target parameter: ".concat(value, " is not a valid input value"));
                  }
                }
                values = [inputValues.secondTenths || 0, inputValues.seconds || 0, inputValues.minutes || 0, inputValues.hours || 0, inputValues.days || 0];
              }
            }
            var secondTenths = values[SECOND_TENTHS_POSITION];
            var seconds = values[SECONDS_POSITION] + calculateIntegerUnitQuotient(secondTenths, SECOND_TENTHS_PER_SECOND);
            var minutes = values[MINUTES_POSITION] + calculateIntegerUnitQuotient(seconds, SECONDS_PER_MINUTE);
            var hours = values[HOURS_POSITION] + calculateIntegerUnitQuotient(minutes, MINUTES_PER_HOUR);
            var days = values[DAYS_POSITION] + calculateIntegerUnitQuotient(hours, HOURS_PER_DAY);
            values[SECOND_TENTHS_POSITION] = secondTenths % SECOND_TENTHS_PER_SECOND;
            values[SECONDS_POSITION] = seconds % SECONDS_PER_MINUTE;
            values[MINUTES_POSITION] = minutes % MINUTES_PER_HOUR;
            values[HOURS_POSITION] = hours % HOURS_PER_DAY;
            values[DAYS_POSITION] = days;
            return values;
          }
          function calculateIntegerUnitQuotient(unit, divisor) {
            var quotient = unit / divisor;
            return quotient < 0 ? Math.ceil(quotient) : Math.floor(quotient);
          }
          function setTarget(inputTarget) {
            if (!inputTarget) {
              return;
            }
            targetValues = configInputValues(inputTarget);
            var targetCounter = calculateTotalCounterFromValues(targetValues);
            targetDate = startingDate + targetCounter.secondTenths * unitsInMilliseconds[SECOND_TENTHS] * timerTypeFactor;
            return targetValues;
          }
          function setStartValues(inputStartValues) {
            startValues = configInputValues(inputStartValues);
            counters.secondTenths = startValues[SECOND_TENTHS_POSITION];
            counters.seconds = startValues[SECONDS_POSITION];
            counters.minutes = startValues[MINUTES_POSITION];
            counters.hours = startValues[HOURS_POSITION];
            counters.days = startValues[DAYS_POSITION];
            totalCounters = calculateTotalCounterFromValues(startValues, totalCounters);
          }
          function calculateTotalCounterFromValues(values, outputCounter) {
            var total = outputCounter || {};
            total.days = values[DAYS_POSITION];
            total.hours = total.days * HOURS_PER_DAY + values[HOURS_POSITION];
            total.minutes = total.hours * MINUTES_PER_HOUR + values[MINUTES_POSITION];
            total.seconds = total.minutes * SECONDS_PER_MINUTE + values[SECONDS_POSITION];
            total.secondTenths = total.seconds * SECOND_TENTHS_PER_SECOND + values[[SECOND_TENTHS_POSITION]];
            return total;
          }
          function stop() {
            stopTimerAndResetCounters();
            dispatchEvent("stopped", eventData);
          }
          function reset() {
            stopTimerAndResetCounters();
            setParamsAndStartTimer(currentParams);
            dispatchEvent("reset", eventData);
          }
          function start() {
            var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            params = _objectSpread2(_objectSpread2({}, defaultParams), params);
            if (isRunning()) {
              return;
            }
            setParamsAndStartTimer(params);
            dispatchEvent("started", eventData);
          }
          function pause() {
            stopTimer();
            paused = true;
            dispatchEvent("paused", eventData);
          }
          function addEventListener(eventType, listener) {
            eventEmitter.on(eventType, listener);
          }
          function removeEventListener(eventType, listener) {
            eventEmitter.removeListener(eventType, listener);
          }
          function dispatchEvent(eventType, data) {
            eventEmitter.emit(eventType, data);
          }
          function isRunning() {
            return running;
          }
          function isPaused() {
            return paused;
          }
          function getTimeValues() {
            return counters;
          }
          function getTotalTimeValues() {
            return totalCounters;
          }
          function getConfig() {
            return timerConfig;
          }
          if (typeof this !== "undefined") {
            this.start = start;
            this.pause = pause;
            this.stop = stop;
            this.reset = reset;
            this.isRunning = isRunning;
            this.isPaused = isPaused;
            this.getTimeValues = getTimeValues;
            this.getTotalTimeValues = getTotalTimeValues;
            this.getConfig = getConfig;
            this.addEventListener = addEventListener;
            this.on = addEventListener;
            this.removeEventListener = removeEventListener;
            this.off = removeEventListener;
          }
        }
        exports2.Timer = Timer3;
        exports2.default = Timer3;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    }
  });

  // app/scripts/common/define.js
  Object.assign(NodeList.prototype, {
    removeClass: function() {
      for (const item of this) {
        item.classList.remove(...arguments);
      }
    },
    addClass: function() {
      for (const item of this) {
        item.classList.add(...arguments);
      }
    },
    addEvents: function(...args) {
      for (const item of this) {
        item.addEvent(...args);
      }
    },
    removeEvents: function(...args) {
      for (const item of this) {
        item.removeEvent(...args);
      }
    }
  });
  Object.assign(HTMLCollection.prototype, {
    removeClass: function() {
      for (const item of this) {
        item.classList.remove(...arguments);
      }
    },
    addClass: function() {
      for (const item of this) {
        item.classList.add(...arguments);
      }
    },
    addEvents: function(...args) {
      for (const item of this) {
        item.addEventListener(...args);
      }
    },
    removeEvents: function(...args) {
      for (const item of this) {
        item.removeEventListener(...args);
      }
    },
    forEach: Array.prototype.forEach
  });
  Object.assign(HTMLElement.prototype, {
    removeClass: function(...args) {
      this.classList.remove(...args);
    },
    addClass: function(...args) {
      this.classList.add(...args);
    },
    hasClass: function(className) {
      return this.classList.contains(className);
    }
  });
  Object.assign(Number.prototype, {
    toCurrency: moneyFormat
  });
  Object.assign(String.prototype, {
    toCurrency: moneyFormat,
    convertToSlug: function() {
      return this.toLowerCase().replace(/-/g, " ").trim().replace(/[\(\)\[\]'"]/g, "").replace(/[^\w]+/g, "-");
    }
  });
  var moneyFormatString = theme.currency.format;
  function moneyFormat(format) {
    let cents = this;
    if (cents instanceof String) {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormatString;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number === null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  (function() {
    let nativeFetch = window.fetch;
    window.fetch = function(...agrs) {
      let dataType = !!agrs[1] ? agrs[1].dataType : "";
      return nativeFetch(...agrs).then((res) => {
        if (!res.ok && res.type === "basic") {
          throw res.json();
        }
        switch (dataType) {
          case "json": {
            return res.json();
          }
          case "text": {
            return res.text();
          }
          default:
            return res;
        }
      });
    };
  })();

  // node_modules/@shopify/theme-images/images.js
  function getSizedImageUrl2(src, size) {
    if (size === null) {
      return src;
    }
    if (size === "master") {
      return removeProtocol(src);
    }
    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];
      return removeProtocol(`${prefix[0]}_${size}${suffix}`);
    } else {
      return null;
    }
  }
  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  // node_modules/@shopify/theme-sections/section.js
  var SECTION_ID_ATTR = "data-section-id";
  function Section(container, properties) {
    this.container = validateContainerElement(container);
    this.id = container.getAttribute(SECTION_ID_ATTR);
    this.extensions = [];
    Object.assign(this, validatePropertiesObject(properties));
    this.onLoad();
  }
  Section.prototype = {
    onLoad: Function.prototype,
    onUnload: Function.prototype,
    onSelect: Function.prototype,
    onDeselect: Function.prototype,
    onBlockSelect: Function.prototype,
    onBlockDeselect: Function.prototype,
    extend: function extend(extension) {
      this.extensions.push(extension);
      var extensionClone = Object.assign({}, extension);
      delete extensionClone.init;
      Object.assign(this, extensionClone);
      if (typeof extension.init === "function") {
        extension.init.apply(this);
      }
    }
  };
  function validateContainerElement(container) {
    if (!(container instanceof Element)) {
      throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
    }
    if (container.getAttribute(SECTION_ID_ATTR) === null) {
      throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + SECTION_ID_ATTR + " attribute.");
    }
    return container;
  }
  function validatePropertiesObject(value) {
    if (typeof value !== "undefined" && typeof value !== "object" || value === null) {
      throw new TypeError("Theme Sections: The properties object provided is not a valid");
    }
    return value;
  }
  if (typeof Object.assign != "function") {
    Object.defineProperty(Object, "assign", {
      value: function assign(target) {
        "use strict";
        if (target == null) {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        var to = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (nextSource != null) {
            for (var nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // node_modules/@shopify/theme-sections/theme-sections.js
  var SECTION_TYPE_ATTR = "data-section-type";
  var SECTION_ID_ATTR2 = "data-section-id";
  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.sections = window.Shopify.theme.sections || {};
  var registered = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
  var instances = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
  function register(type, properties) {
    if (typeof type !== "string") {
      throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
    }
    if (typeof registered[type] !== "undefined") {
      throw new Error('Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice');
    }
    function TypedSection(container) {
      Section.call(this, container, properties);
    }
    TypedSection.constructor = Section;
    TypedSection.prototype = Object.create(Section.prototype);
    TypedSection.prototype.type = type;
    return registered[type] = TypedSection;
  }
  function load(types, containers) {
    types = normalizeType(types);
    if (typeof containers === "undefined") {
      containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
    }
    containers = normalizeContainers(containers);
    types.forEach(function(type) {
      var TypedSection = registered[type];
      if (typeof TypedSection === "undefined") {
        return;
      }
      containers = containers.filter(function(container) {
        if (isInstance(container)) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
          return true;
        }
        instances.push(new TypedSection(container));
        return false;
      });
    });
  }
  function unload(selector) {
    var instancesToUnload = getInstances(selector);
    instancesToUnload.forEach(function(instance) {
      var index = instances.map(function(e) {
        return e.id;
      }).indexOf(instance.id);
      instances.splice(index, 1);
      instance.onUnload();
    });
  }
  function getInstances(selector) {
    var filteredInstances = [];
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
      var firstElement = selector[0];
    }
    if (selector instanceof Element || firstElement instanceof Element) {
      var containers = normalizeContainers(selector);
      containers.forEach(function(container) {
        filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
          return instance.container === container;
        }));
      });
    } else if (typeof selector === "string" || typeof firstElement === "string") {
      var types = normalizeType(selector);
      types.forEach(function(type) {
        filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
          return instance.type === type;
        }));
      });
    }
    return filteredInstances;
  }
  function getInstanceById(id) {
    var instance;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].id === id) {
        instance = instances[i];
        break;
      }
    }
    return instance;
  }
  function isInstance(selector) {
    return getInstances(selector).length > 0;
  }
  function normalizeType(types) {
    if (types === "*") {
      types = Object.keys(registered);
    } else if (typeof types === "string") {
      types = [types];
    } else if (types.constructor === Section) {
      types = [types.prototype.type];
    } else if (Array.isArray(types) && types[0].constructor === Section) {
      types = types.map(function(TypedSection) {
        return TypedSection.prototype.type;
      });
    }
    types = types.map(function(type) {
      return type.toLowerCase();
    });
    return types;
  }
  function normalizeContainers(containers) {
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
      containers = Array.prototype.slice.call(containers);
    } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
      containers = [];
    } else if (containers === null) {
      containers = [];
    } else if (!Array.isArray(containers) && containers instanceof Element) {
      containers = [containers];
    }
    return containers;
  }
  if (window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector("[" + SECTION_ID_ATTR2 + '="' + id + '"]');
      if (container !== null) {
        load(container.getAttribute(SECTION_TYPE_ATTR), container);
      }
    });
    document.addEventListener("shopify:section:unload", function(event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector("[" + SECTION_ID_ATTR2 + '="' + id + '"]');
      var instance = getInstances(container)[0];
      if (typeof instance === "object") {
        unload(container);
      }
    });
    document.addEventListener("shopify:section:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onSelect(event);
      }
    });
    document.addEventListener("shopify:section:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onDeselect(event);
      }
    });
    document.addEventListener("shopify:block:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockSelect(event);
      }
    });
    document.addEventListener("shopify:block:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockDeselect(event);
      }
    });
  }

  // app/scripts/common.js
  var import_easytimer = __toModule(require_easytimer());

  // app/scripts/common/function/debounce.js
  var debounce = (func, wait) => {
    let timeout;
    return function(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // app/scripts/common/function/backToTop.js
  var backToTop = function() {
    let target = document.getElementById("back-to-top");
    target.addEvent("click", () => {
      AT.scrollTo(0);
    });
    if (window.pageYOffset > window.innerHeight * 1.5) {
      target.addClass("show");
    }
    window.addEvent("scroll", () => {
      if (window.pageYOffset > window.innerHeight * 1.5) {
        target.addClass("show");
      } else {
        target.hasClass("show") && target.removeClass("show");
      }
    });
  };

  // app/scripts/common/function/enableScroll.js
  function enableScroll() {
    document.documentElement.style.paddingRight = "";
    document.documentElement.removeClass("overflow-hidden");
  }

  // app/scripts/common/function/disableScroll.js
  function disableScroll() {
    let paddingRight = window.innerWidth - document.documentElement.offsetWidth + "px";
    document.documentElement.style.paddingRight = paddingRight;
    document.documentElement.addClass("overflow-hidden");
  }

  // app/scripts/common/function/loadCartNotify.js
  var loadCartNotify = () => {
    return new Promise((resolve, reject) => {
      AT.loadScript(theme.assets.cartNotify, () => {
        document.dispatchEvent(new CustomEvent("cart-notify-initialized"));
      });
      document.addEvent("cart-notify-initialized", function() {
        resolve(1);
      });
    });
  };

  // app/scripts/common/function/loadScript.js
  var loadScript = (url, cb) => {
    let script = document.createElement("script");
    script.src = url;
    !!cb && (script.onload = cb);
    script.onError = () => {
      console.warn("Has an error when loading script:", url);
    };
    document.body.append(script);
  };

  // app/scripts/common/function/initTabPanel.js
  var initTabPanel = (container) => {
    try {
      let tabControls = container.querySelector(".js-tab-controls");
      let tabContents = container.querySelector(".js-tab-contents");
      [...tabControls.children].forEach((item) => {
        let target = tabContents.querySelector(item.dataset.target);
        item.addEvent("click", () => {
          if (item.hasClass("active")) {
            return;
          }
          tabControls.children.removeClass("active");
          tabContents.children.removeClass("active");
          item.addClass("active");
          target.addClass("active");
        });
      });
    } catch (error) {
      console.warn("Has an error from Tab Panel function:", error);
      console.log(container);
    }
  };

  // app/scripts/common/function/inputQuantity.js
  var initInputQuantity = (container) => {
    if (!container) {
      return;
    }
    let btnPlus = container.querySelector(".js-qty-plus");
    let btnMinus = container.querySelector(".js-qty-minus");
    let input = container.querySelector("input");
    btnPlus.addEvent("click", () => {
      let max = !!input.max ? +input.max : void 0;
      let value = +input.value;
      if (!!max) {
        if (value < max) {
          input.value = ++value;
          input.dispatchEvent(new Event("change"));
        }
      } else {
        input.value = ++value;
        input.dispatchEvent(new Event("change"));
      }
    });
    btnMinus.addEvent("click", () => {
      let value = input.value;
      if (value > 1) {
        input.value = --value;
        input.dispatchEvent(new Event("change"));
      }
    });
    input.addEvent("change", function() {
      let min = !!this.min ? this.min : void 0;
      let max = !!this.max ? this.max : void 0;
      let value = +this.value;
      if (!!min && value < min) {
        this.value = min;
      }
      if (!!max & value > max) {
        this.value = max;
      }
    });
  };

  // app/scripts/common/function/scrollTo.js
  var scrollTo = (position) => {
    let pageYoffset = window.pageYOffset;
    let boolean = position - pageYoffset > 0 ? true : false;
    let distance = Math.abs((pageYoffset - position) / 10);
    requestAnimationFrame(step);
    function step() {
      if (boolean) {
        if (pageYoffset < position) {
          window.scrollTo(0, (pageYoffset += distance) > position ? position : pageYoffset);
          requestAnimationFrame(step);
        }
      } else {
        if (pageYoffset > position) {
          window.scrollTo(0, pageYoffset >= distance ? pageYoffset -= distance : (pageYoffset = position - 1, position));
          requestAnimationFrame(step);
        }
      }
    }
  };

  // app/scripts/common/function/formAddToCart.js
  var initFormAddToCart = (form) => {
    if (!form) {
      return;
    }
    let btnAddToCart = form.querySelector(".btn-add-to-cart");
    form.addEvent("submit", (e) => {
      e.preventDefault();
      btnAddToCart.addClass("pending");
      Cart.add(form).then(() => {
        btnAddToCart.removeClass("pending");
      });
    });
  };

  // app/scripts/common/function/cookie.js
  var cookie = {
    get: function(key) {
      var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
      return keyValue ? JSON.parse(keyValue[2]) : null;
    },
    set: function(key, value, expiry) {
      var expires = new Date();
      expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1e3);
      document.cookie = key + "=" + JSON.stringify(value) + ";expires=" + expires.toUTCString() + ";path=/";
    },
    delete: function(key) {
      var keyValue = this.get(key);
      this.set(key, keyValue, "-1");
    }
  };

  // app/scripts/common/function/initCountDown.js
  var initCountDown = (element) => {
    let daysElm = element.querySelector(".js-countdown-days");
    let hoursElm = element.querySelector(".js-countdown-hours");
    let minutesElm = element.querySelector(".js-countdown-minutes");
    let secondsElm = element.querySelector(".js-countdown-seconds");
    let date = new Date(element.dataset.countdown).getTime() - new Date().getTime();
    let timer = new Timer();
    timer.start({ countdown: true, startValues: { seconds: date / 1e3 } });
    timer.addEventListener("secondsUpdated", function(e) {
      let days = timer.getTimeValues().days;
      let hours = timer.getTimeValues().hours;
      let minutes = timer.getTimeValues().minutes;
      let seconds = timer.getTimeValues().seconds;
      daysElm.innerHTML = days > 9 ? days : `0${days}`;
      hoursElm.innerHTML = hours > 9 ? hours : `0${hours}`;
      minutesElm.innerHTML = minutes > 9 ? minutes : `0${minutes}`;
      secondsElm.innerHTML = seconds > 9 ? seconds : `0${seconds}`;
    });
  };

  // app/scripts/common/function/loadSearch.js
  var loadSearch = () => {
    return new Promise((resolve, reject) => {
      AT.loadScript(theme.assets.search, () => {
        resolve(1);
      });
    });
  };

  // app/scripts/common/function/searchDrawer.js
  var searchDrawer = {
    loaded: false,
    load: function() {
      let template = document.getElementById("drawer-search-template");
      return new Promise((resolve, reject) => {
        let drawerContainer = template.content.firstElementChild;
        template.insertAdjacentElement("beforebegin", drawerContainer);
        template.remove();
        this.container = drawerContainer;
        this.loaded = true;
        let closeButtons = drawerContainer.querySelectorAll(".js-drawer-close");
        closeButtons.addEvents("click", () => {
          this.close();
        });
        if (typeof Search !== "undefined") {
          new Search(this.container);
        } else {
          AT.loadSearch().then(() => new Search(this.container));
        }
        resolve(1);
      });
    },
    open: function() {
      this.container.addClass("is-open");
      AT.disableScroll();
    },
    close: function() {
      this.container.removeClass("is-open");
      AT.debounce(() => {
        AT.enableScroll();
      }, 100)();
    }
  };

  // app/scripts/common/function/initEventMobileBar.js
  var initEventMobileBar = () => {
    document.addEvent("lazyincluded", (e) => {
      let container = e.target;
      if (e.target.dataset.type === "mobile-bar") {
        let buttonWishlist = container.querySelector(".show-wishlist");
        let searchButton = container.querySelector(".js-mobile-bar-open");
        !!buttonWishlist && buttonWishlist.addEvent("click", () => {
          document.dispatchEvent(new CustomEvent("show-layout"));
        });
        !!searchButton && searchButton.addEvent("click", () => {
          if (!AT.searchDrawer.loaded) {
            AT.searchDrawer.load().then(AT.debounce(() => AT.searchDrawer.open(), 100));
          } else {
            AT.searchDrawer.open();
          }
        });
      }
    });
  };

  // app/scripts/common/function/loadCollectionFilter.js
  var loadCollectionFilter = () => {
    return new Promise((resolve, reject) => {
      AT.loadScript(theme.assets.collectionFilter, () => resolve(1));
    });
  };

  // app/scripts/common/function/loadCurrencies.js
  var loadCurrencies = () => {
    return new Promise((resolve, reject) => {
      AT.loadScript(theme.assets.currenciesRateUrl, () => {
        AT.loadScript(theme.assets.currenciesUrl, () => {
          resolve(1);
        });
      });
    });
  };

  // app/scripts/common/function/detectVisible.js
  var detectVisible = ({ element, rootMargin, callback, threshold = 0 }) => {
    let observer = new IntersectionObserver((entries, observer2) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback();
          observer2.unobserve(element);
        }
      });
    }, { rootMargin });
    observer.observe(element);
  };

  // app/scripts/common/function/getParameterByName.js
  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results)
      return null;
    if (!results[2])
      return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // app/scripts/common/model/cart.js




  // app/scripts/common/model/sendMessage.js
  var SendMessage2 = class {
    constructor() {
      let container = this.container = document.getElementById("modal-message");
      this.elms = {
        messageElm: container.querySelector(".js-message")
      };
      this.modal = new Popup(container);
    }
    open(message) {
      this.elms.messageElm.innerHTML = message;
      this.modal.open();
    }
  };

  // app/scripts/common/model/popup.js
  var Popup2 = class {
    constructor(container) {
      this.container = container;
      this.container.getElementsByClassName("js-modal-close").addEvents("click", this.close.bind(this));
    }
    close() {
      this.container.removeClass("is-open");
      AT.enableScroll();
    }
    open() {
      this.container.addClass("is-open");
      AT.disableScroll();
    }
  };

  // app/scripts/common/section/header.js
  var Header = {
    onLoad: function() {
      let { container } = this;
      theme.settings.header.sticky && this.initSticky();
      this.elms = {
        mainMegaMenuLazyContainer: document.getElementById("main-mega-menu"),
        subMegaMenuLazyContainer: document.getElementById("sub-mega-menu"),
        mainSublinksLazyContainer: document.getElementById("header-menu-sublinks"),
        searchFormContainer: container.querySelector(".js-header-search"),
        searchDrawerOpenButton: container.querySelector(".js-open-search-drawer")
      };
      this.initEventDesktop();
      this.initEventMobile();
      this.initEventButtonSearch();
      this.initSearch();
    },
    initEventButtonSearch: function() {
      let { searchDrawerOpenButton } = this.elms;
      if (!!searchDrawerOpenButton) {
        searchDrawerOpenButton.addEvent("click", () => {
          if (!AT.searchDrawer.loaded) {
            AT.searchDrawer.load().then(AT.debounce(() => AT.searchDrawer.open(), 100));
          } else {
            AT.searchDrawer.open();
          }
        });
      }
    },
    initSticky: function() {
      let headerContainer = document.getElementById("header");
      let headerHeight = headerContainer.clientHeight;
      window.addEventListener("scroll", function() {
        if (window.pageYOffset >= headerHeight) {
          headerContainer.style.height = headerHeight + "px";
          headerContainer.classList.add("header-sticky");
        } else {
          headerContainer.style.height = "";
          headerContainer.classList.remove("header-sticky");
        }
      });
      if (window.pageYOffset >= headerHeight) {
        headerContainer.style.height = headerHeight + "px";
        headerContainer.classList.add("header-sticky");
      }
    },
    initEventDesktop: function() {
      let { mainMegaMenuLazyContainer, mainSublinksLazyContainer, subMegaMenuLazyContainer } = this.elms;
      let mainDeskMegaMenu = !!mainMegaMenuLazyContainer ? !!mainMegaMenuLazyContainer.content ? mainMegaMenuLazyContainer.content.firstElementChild : mainMegaMenuLazyContainer : "";
      let mainDeskSublinksMenu = !!mainSublinksLazyContainer ? !!mainSublinksLazyContainer.content ? mainSublinksLazyContainer.content.firstElementChild : mainSublinksLazyContainer : "";
      let subDeskMegaMenu = !!subMegaMenuLazyContainer ? !!subMegaMenuLazyContainer.content ? subMegaMenuLazyContainer.content.firstElementChild : subMegaMenuLazyContainer : "";
      if (window.innerWidth > 992) {
        init();
      } else {
        document.addEvent("desktop-lazyloaded", init);
      }
      function init() {
        let deskMainLazy = document.getElementById("header_main_menu").querySelectorAll(".desk-lazy-menu");
        let deskSubLazy = document.getElementById("header-second-nav");
        [...deskMainLazy].forEach((element) => {
          element.addEvent("mouseover", addLazyload.bind(element, mainDeskMegaMenu, mainDeskSublinksMenu), {
            once: true
          });
        });
        !!deskSubLazy && [...deskSubLazy.querySelectorAll(".desk-lazy-menu")].forEach((element) => {
          element.addEvent("mouseover", addLazyload.bind(element, subDeskMegaMenu, mainDeskSublinksMenu), {
            once: true
          });
        });
        function addLazyload(megaMenu, menuSublinks) {
          let lazyElement = this.querySelector(".js-lazy-menu");
          let targetID = lazyElement.dataset.targetId;
          let lazyResource = lazyElement.dataset.lazyResource;
          switch (lazyResource) {
            case "mega-menu": {
              let lazyTarget = megaMenu.querySelector(`[data-id="${targetID}"]`);
              lazyElement.innerHTML = lazyTarget.innerHTML;
              break;
            }
            case "menu-sublinks": {
              let lazyTarget = menuSublinks.querySelector(`[data-id="${targetID}"]`);
              lazyElement.innerHTML = lazyTarget.innerHTML;
              break;
            }
          }
          if (typeof Currencies !== "undefined") {
            lazyElement.querySelectorAll(".js-money").forEach(Currencies.registerObserve.bind(Currencies));
          }
        }
      }
    },
    initEventMobile: function() {
      let { container } = this;
      let mobileDrawerLoaded = false;
      let { mainMegaMenuLazyContainer, subMegaMenuLazyContainer, mainSublinksLazyContainer } = this.elms;
      let mainMobileLazy = !!mainMegaMenuLazyContainer ? !!mainMegaMenuLazyContainer.content ? mainMegaMenuLazyContainer.content.lastElementChild : mainMegaMenuLazyContainer : "";
      let subMobileLazy = !!subMegaMenuLazyContainer ? !!subMegaMenuLazyContainer.content ? subMegaMenuLazyContainer.content.lastElementChild : subMegaMenuLazyContainer : "";
      let menuSublinksLazy = !!mainSublinksLazyContainer ? !!mainSublinksLazyContainer.content ? mainSublinksLazyContainer.content.lastElementChild : mainSublinksLazyContainer : "";
      const init = () => {
        let headerContainer = container.querySelector("#header-mobile-container");
        let toggleMainDrawerButton = headerContainer.querySelector(".js-main-drawer-open-button");
        let toggleSubDrawerButton = headerContainer.querySelector(".js-sub-drawer-open-button");
        let mainDrawerContainer = container.querySelector("#mobile-drawer-main");
        if (!!mainDrawerContainer) {
          let mainDrawerTemplate = mainDrawerContainer.firstElementChild;
          toggleMainDrawerButton.addEvent("click", loadMenuLazy.bind(toggleMainDrawerButton, mainDrawerContainer, mainDrawerTemplate, mainMobileLazy, menuSublinksLazy));
        }
        let subDrawerContainer = container.querySelector("#mobile-drawer-sub");
        if (!!subDrawerContainer) {
          let subDrawerTemplate = subDrawerContainer.firstElementChild;
          toggleSubDrawerButton.addEvent("click", loadMenuLazy.bind(toggleSubDrawerButton, subDrawerContainer, subDrawerTemplate, subMobileLazy, menuSublinksLazy));
        }
        function loadMenuLazy(drawerContainer, drawerTemplate, megaMenuLazyContainer, menuSublinksContainer) {
          if (!drawerContainer.hasClass("menu-lazy-loaded")) {
            drawerContainer.innerHTML = drawerTemplate.content.firstElementChild.outerHTML;
            drawerContainer.addClass("menu-lazy-loaded");
            initBtnClose(drawerContainer, drawerContainer);
            initBtnToggle2(drawerContainer, drawerContainer);
            drawerContainer.querySelectorAll(".js-toggle-menu").forEach((button) => {
              let target = drawerContainer.querySelector(`#${button.dataset.target}`);
              button.addEvent("click", function() {
                let id = target.dataset.targetId;
                let lazyResource = target.dataset.lazyResource;
                switch (lazyResource) {
                  case "mega-menu":
                    target.innerHTML = megaMenuLazyContainer.querySelector(`[data-id='${id}']`).innerHTML;
                    break;
                  case "menu-sublinks":
                    target.innerHTML = menuSublinksContainer.querySelector(`[data-id='${id}']`).innerHTML;
                    break;
                }
                if (typeof Currencies !== "undefined") {
                  target.querySelectorAll(".js-money").forEach(Currencies.registerObserve.bind(Currencies));
                }
                initBtnClose(target, drawerContainer);
                initBtnToggle2(target, drawerContainer);
                target.addEvent("reInit-event", initBtnToggle2.bind(null, target, drawerContainer));
              }, { once: true });
            });
          }
          drawerContainer.addClass("is-open");
          AT.disableScroll();
          function initBtnToggle2(container2, drawerContainer2) {
            let btnToggler = container2.getElementsByClassName("js-toggle-menu");
            btnToggler.forEach((button) => {
              let { role, target } = button.dataset;
              let targetElement = drawerContainer2.querySelector(`#${target}`);
              button.addEvent("click", () => {
                switch (role) {
                  case "next":
                    targetElement.addClass("is-open");
                    break;
                  case "previous":
                    targetElement.removeClass("is-open");
                    break;
                }
              });
            });
          }
        }
        function initBtnClose(container2, drawerContainer) {
          let buttonsClose = container2.getElementsByClassName("js-btn-close");
          buttonsClose.addEvents("click", () => {
            drawerContainer.removeClass("is-open");
            AT.enableScroll();
          });
        }
        return;
        const loadSubMenu = () => {
          let mobileMenuLazy = mobileDrawerMain.getElementsByClassName("js-mobi-menu-lazy");
        };
        btnOpenDrawer.addEvent("click", () => {
          if (!mobileDrawerLoaded) {
            mobileDrawerLoaded = true;
            insertMobileDrawer();
            initBtnClose(mobileDrawerMain);
            initBtnToggle(mobileDrawerMain);
            loadSubMenu();
          }
          mobileDrawerMain.addClass("is-open");
          AT.disableScroll();
        });
      };
      if (window.innerWidth < 992) {
        init();
      } else {
        document.addEvent("mobile-lazyloaded", init);
      }
    },
    initSearch: function() {
      let { searchFormContainer } = this.elms;
      if (!searchFormContainer) {
        return;
      }
      if (typeof Search !== "undefined") {
        new Search(searchFormContainer);
      } else {
        AT.loadSearch().then(() => {
          new Search(searchFormContainer);
        });
      }
    }
  };

  // app/scripts/common/section/footer.js
  var Footer = {
    onLoad() {
      let { container } = this;
      try {
        if (Shopify.designMode) {
          this.initEvent();
        } else {
          AT.detectVisible({
            element: container,
            rootMargin: "1000px 0px 2000px 0px",
            callback: () => {
              let { url } = container.dataset;
              fetch(url, { dataType: "json" }).then((content) => {
                container.innerHTML = Object.keys(content).map((key) => content[key]).join("");
                this.initEvent();
              });
            }
          });
        }
      } catch (error) {
        console.warn(error);
        console.log(container);
      }
    },
    initEvent() {
      this.container.getElementsByClassName("js-btn-collapse").forEach((button) => {
        let targetElement = document.getElementById(button.dataset.target);
        button.addEvent("click", function() {
          if (this.hasClass("active")) {
            this.removeClass("active");
            targetElement.removeClass("is-open");
          } else {
            this.addClass("active");
            targetElement.addClass("is-open");
          }
        });
      });
    }
  };

  // app/scripts/common/section/newsletter.js
  var Newsletter = {
    onLoad() {
      let { container } = this;
      let { url } = container.dataset;
      if (Shopify.designMode) {
        this.initEvent();
      } else {
        this.loadTemplate(url).then(this.initEvent.bind(this));
      }
    },
    initEvent() {
      if (AT.cookie.get("arn-newsletter")) {
        return;
      }
      this.modal = new Popup(this.container.querySelector("#modal_newsletter"));
      AT.debounce(this.modal.open.bind(this.modal), 15e3)();
      let form = this.container.querySelector("form");
      let { type } = form.dataset;
      switch (type) {
        case "klaviyo":
          this.handleKlaviyo(form);
          break;
        case "mailchimp":
          this.handleMailChimp(form);
          break;
      }
      AT.cookie.set("arn-newsletter", "true", 2);
    },
    handleKlaviyo(form) {
      window.addEvent("load", () => {
        AT.loadScript("//www.klaviyo.com/media/js/public/klaviyo_subscribe.js", () => {
          KlaviyoSubscribe.attachToForms(form, {
            custom_success_message: true,
            success: () => {
              this.modal.close();
              AT.debounce(() => SendMessage.open(theme.strings.klaviyoSuccess), 200)();
            }
          });
        });
      });
    },
    handleMailChimp(form) {
      window.mailChimpCallBack = ({ result, msg }) => {
        this.modal.close();
        AT.debounce(() => SendMessage.open(msg), 200)();
      };
      let action = form.getAttribute("action") + "&c=mailChimpCallBack";
      form.addEvent("submit", (e) => {
        e.preventDefault();
        AT.loadScript(action + `&EMAIL=${encodeURIComponent(form.querySelector("input[name=EMAIL]").value)}`);
      });
    },
    loadTemplate(url) {
      return fetch(url, { dataType: "text" }).then((content) => {
        this.container.innerHTML = content;
      });
    },
    onSelect() {
      console.log(this);
      this.modal.open();
    },
    onDeselect() {
      this.modal.close();
    }
  };

  // app/scripts/common.js
  (() => {
    window.AT = {
      debounce,
      backToTop,
      scrollTo,
      disableScroll,
      enableScroll,
      loadCartNotify,
      loadScript,
      getSizedImageUrl: getSizedImageUrl2,
      initTabPanel,
      initInputQuantity,
      initFormAddToCart,
      cookie,
      initCountDown,
      reviewBadgeSaved: {},
      loadSearch,
      searchDrawer,
      loadCollectionFilter,
      loadCurrencies,
      detectVisible,
      getParameterByName
    };
    window.Popup = Popup2;
    register("header-container", Header);
    register("newsletter", Newsletter);
    register("footer", Footer);
    load("*");
    window.register = register;
    window.load = load;
    window.Timer = import_easytimer.Timer;
    initEventMobileBar();


    let modalCurrenciesLanguages = document.getElementById("modal-currency-vs-language");
    if (!!modalCurrenciesLanguages) {
      document.addEvent("open-modal-currencies-languages", () => {
        modalCurrenciesLanguages.addClass("is-open");
      });
      document.addEvent("open-modal-currencies-languages", () => {
        if (typeof Currencies === "undefined" && theme.currency.type != "shopify") {
          AT.loadCurrencies().then(() => console.log("Currencies Finished")).catch((error) => {
            alert("Has an error on process loading Currencies function.");
            console.log(error);
          });
        }
      }, { once: true });
    }


    console.log("common.js loaded");
    document.dispatchEvent(new CustomEvent("common.js loaded"));
  })();
})();



(() => {




  var BannerFilter = {
    onLoad: function() {
      if (typeof Filter === "undefined") {
        AT.loadCollectionFilter().then(() => {
          new Filter(this.container.querySelector(".chosen-wrapper"));
        });
      } else {
        new Filter(this.container.querySelector(".chosen-wrapper"));
      }
    }
  };



if($("#ARM_Filtter").length > 0) {
  (function() {


  
  theme.sectionRegister.forEach(registerSection);


    load("*");



    function registerSection(type) {
      switch (type) {

        case "banner-filter":
          register(type, BannerFilter);
          break;
       
        
      }
    }
    
  })();

};

})();
